import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js"

export default class extends Controller {
  static targets = ['insuranceCompanyInput', 'investmentFundInput']

  async updateForm() {
    const insurance_company_id = this.insuranceCompanyInputTarget.value
    const index = this.element.dataset.index
    const detail_id = this.element.dataset.detailId
    const calculator_id = this.element.dataset.calculatorId
    const url = `/agents/funds_comparison_calculators/${calculator_id}/update_investment_fund_form`

    await patch(url, {
      body: JSON.stringify({
        insurance_company_id,
        index,
        detail_id
      }),
      responseKind: "turbo-stream",
    })
  }

  async add() {
    const calculator_id = this.element.dataset.calculatorId
    const url = `/agents/funds_comparison_calculators/${calculator_id}/add_investment_fund`

    await patch(url, {
      body: JSON.stringify({
        investment_fund_id: this.investmentFundInputTarget.value
      }),
      responseKind: "turbo-stream",
    })
  }

  async update() {
    const calculator_id = this.element.dataset.calculatorId
    const url = `/agents/funds_comparison_calculators/${calculator_id}/update_investment_fund`

    await patch(url, {
      body: JSON.stringify({
        investment_fund_id: this.investmentFundInputTarget.value,
        detail_id: this.element.dataset.detailId
      }),
      responseKind: "turbo-stream",
    })
  }
}
